import { CaptureUserToSentry } from '@/components/CaptureUserToSentry'
import { useClientOnly } from '@/hooks/useClientOnly'
import { useQuery } from '@/hooks/useQuery'
import { graphql } from 'gql.tada'
import Router from 'next/router'
import React, { use } from 'react'
import { GuardianLayout } from '../guardian'
import { ContractSignErrorBoundary } from './ContractSignErrorBoundary'

interface WebSignedInLayoutProps {
  children: React.ReactNode
}

const WebSignedInLayout_Query = graphql(`
  query WebSignedInLayout_Query {
    currentUser {
      __typename
      ... on User {
        id
      }
      ... on SchoolUser {
        id
      }
    }
  }
`)

export function WebSignedInLayout(props: WebSignedInLayoutProps) {
  useClientOnly()

  if (!localStorage.getItem('accessToken')) {
    use(Router.replace('/web/sign_in/'))
  }

  return (
    <GuardianLayout>
      <ContractSignErrorBoundary>
        <CaptureUserToSentry />
        <RedirectForSchoolUser>{props.children}</RedirectForSchoolUser>
      </ContractSignErrorBoundary>
    </GuardianLayout>
  )
}

export function RedirectForSchoolUser(props: WebSignedInLayoutProps) {
  const [result] = useQuery({ query: WebSignedInLayout_Query })

  const currentUser = result.data?.currentUser

  if (currentUser?.__typename == 'SchoolUser')
    throw Router.replace('/web/school-admin/')

  return props.children
}

export function getWebSignedInLayout(page: React.ReactElement) {
  return <WebSignedInLayout>{page}</WebSignedInLayout>
}
